// Kept out of `api-client.ts` so the client stays DOM-free.
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.rel = 'noopener';
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    // Revoking synchronously can cancel the in-flight save in some browsers.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
